import { JSX, MouseEvent } from 'react'

import { Tooltip } from 'core-components/library/tooltip'
import { formatFixedNumber } from 'partner360/lib/metricFormatting'

import styles from '../MarketYoyGrowthExpectationTable.module.scss'
import { IGrowthValueRange, isGrowthValueRange, TGrowthValue } from '../types'

interface IRenderGrowthValueRangeParams {
  value: IGrowthValueRange
  /** When provided, the range display becomes clickable (e.g. to open the mixed-cell editor). */
  onClick?: (event: MouseEvent) => void
}

export const renderGrowthValueRange = ({
  value,
  onClick,
}: IRenderGrowthValueRangeParams): JSX.Element => (
  <div
    className={[styles.growthValue, onClick ? styles.growthValueMixed : undefined]
      .filter(Boolean)
      .join(' ')}
    onClick={onClick}
  >
    <Tooltip
      tipContent={() => (
        <>
          {`min ${formatFixedNumber(value.min, 1)}`}
          <br />
          {`max ${formatFixedNumber(value.max, 1)}`}
        </>
      )}
    >
      <span>{`${formatFixedNumber(value.min, 1)} - ${formatFixedNumber(value.max, 1)}`}</span>
    </Tooltip>
  </div>
)

export const renderGrowthValue = (value: TGrowthValue): JSX.Element => {
  if (value === null) {
    return <span className={styles.growthValue}>—</span>
  }

  if (isGrowthValueRange(value)) {
    return renderGrowthValueRange({ value })
  }

  return <span className={styles.growthValue}>{formatFixedNumber(value, 1)}</span>
}
